import { type SocketMachineContext } from '../../network-state-machine-context';

export function onExitActive<
  T extends Pick<
    SocketMachineContext,
    'pendingMessages' | 'socketDisposeListeners' | 'webSocket'
  >
>(ctx: T) {
  ctx.pendingMessages.setPredicate(() => false);

  ctx.socketDisposeListeners?.();
  ctx.socketDisposeListeners = undefined;

  ctx.webSocket?.close();
  ctx.webSocket = undefined;
}
